import { FaCloud, FaBrain, FaCode, FaLightbulb, FaServer, FaPlug, FaShieldAlt, FaLifeRing } from 'react-icons/fa';

const features = [
    {
        id: 1,
        icon: <FaCloud />, // Cloud icon for Cloud Computing
        title: 'Cloud Computing',
        description: 'Leverage secure, scalable, and cost-effective cloud solutions to streamline your operations.',
    },
    {
        id: 2,
        icon: <FaBrain />, // Brain icon for AI Solutions
        title: 'AI Solutions',
        description: 'Transform your business with advanced AI tools designed for growth and innovation.',
    },
    {
        id: 3,
        icon: <FaCode />, // Code icon for Custom Software
        title: 'Custom Software',
        description: 'Develop customized software solutions crafted to address the unique challenges.',
    },
    {
        id: 4,
        icon: <FaLightbulb />, // Lightbulb icon for Consulting Service
        title: 'Consulting Service',
        description: 'Partner with our experts to create forward-thinking strategies that drive success.',
    },
    {
        id: 5,
        icon: <FaServer />, // Server icon for IT Infrastructure
        title: 'IT Infrastructure',
        description: 'Enhance your business operations with IT solutions designed to be scalable & secure.',
    },
    {
        id: 6,
        icon: <FaPlug />, // Plug icon for Custom Integrations
        title: 'Custom Integrations',
        description: 'Integrate our AI solutions seamlessly into your existing systems and processes.',
    },
    {
        id: 7,
        icon: <FaShieldAlt />, // Shield icon for Cybersecurity
        title: 'Cyber Security',
        description: 'Protect your business with state-of-the-art cybersecurity solutions tailored to your needs.',
    },
    {
        id: 8,
        icon: <FaLifeRing />, // Life Ring icon for 24/7 Support
        title: '24/7 Support',
        description: 'Enjoy round-the-clock support from our dedicated team to ensure smooth and efficient operations.',
    },
];

export default features;